import { cva } from 'class-variance-authority';

export const wrapperClasses = cva(
  'relative flex w-full flex-nowrap items-start rounded-lg px-9 py-3'
);

export const iconContainerClasses = cva('absolute cursor-pointer', {
  variants: {
    position: {
      leading: 'top-3-5 left-3',
      trailing: 'top-3 right-3'
    }
  },
  defaultVariants: {
    position: 'leading'
  }
});
